(function () {
  // ============================================================
  // Fab Global Tracking Core
  // ============================================================

  // ============================================================
  // Helpers
  // ============================================================
  if (!window.__fabTrackingHelpers) {
    window.__fabTrackingHelpers = {
      uuid: function () {
        if (window.crypto && typeof window.crypto.randomUUID === "function") {
          return window.crypto.randomUUID();
        }
        return "id_" + Math.random().toString(16).slice(2) + Date.now().toString(16);
      },

      isPosthogReady: function () {
        return !!(window.posthog && typeof window.posthog.capture === "function");
      },

      capture: function (eventName, props) {
        try {
          // Always queue first
          window.__fab_phq = window.__fab_phq || [];
          window.__fab_phq.push([eventName, props || {}]);

          // If we've declared PostHog ready, flush immediately
          if (window.__fab_posthog_ready && window.posthog && typeof window.posthog.capture === "function") {
            // Flush just the thing we queued (cheap)
            var item = window.__fab_phq.pop();
            window.posthog.capture(item[0], item[1] || {});
          }
        } catch (e) {}
      },

      // Deduped search_performed for /search (initial render + facet AJAX).
      // Signature = query|page|sort|filters_applied — re-fires only when state changes.
      // If the user submitted from the header predictive modal, sessionStorage
      // carries source=predictive_submit so we emit one event with full counts
      // instead of a null-count submit + a results_page duplicate.
      fireSearchPerformedFromDom: function (rootEl) {
        try {
          var root = rootEl || document;
          var node = root.querySelector
            ? root.querySelector("[data-fab-search-performed]")
            : null;
          if (!node && root.matches && root.matches("[data-fab-search-performed]")) node = root;
          if (!node) return false;
          var props = JSON.parse(node.textContent || "{}");
          if (!props || typeof props.query !== "string") return false;
          try {
            var filterCount = 0;
            new URLSearchParams(window.location.search).forEach(function (value, key) {
              if (key.indexOf("filter.") === 0 && value) filterCount += 1;
            });
            props.filters_applied = filterCount;
          } catch (e) {}

          try {
            var raw = sessionStorage.getItem("fab_search_source");
            if (raw) {
              var handoff = JSON.parse(raw);
              sessionStorage.removeItem("fab_search_source");
              if (
                handoff &&
                handoff.source === "predictive_submit" &&
                (!handoff.query || handoff.query === props.query) &&
                typeof handoff.t === "number" &&
                Date.now() - handoff.t < 60000
              ) {
                props.source = "predictive_submit";
              }
            }
          } catch (e) {}

          var signature = [
            props.query,
            props.page_number,
            props.sort_by || "",
            props.filters_applied,
            props.source || "results_page"
          ].join("|");
          if (window.__fabSearchPerformedSig === signature) return false;
          window.__fabSearchPerformedSig = signature;
          window.__fabTrackingHelpers.capture("search_performed", props);
          return true;
        } catch (e) {
          return false;
        }
      },

      // Do not let null/"" override real values when merging contexts
      mergePreferDefined: function (base, override) {
        const out = Object.assign({}, base || {});
        if (!override) return out;

        for (const k in override) {
          const v = override[k];
          if (v === null || v === undefined) continue;
          if (typeof v === "string" && v.trim() === "") continue;
          out[k] = v;
        }
        return out;
      },

      buildContextFromEl: function (el, opts) {
        opts = opts || {};
        if (!el) return {};

        const ctx = {
          surface_type: el.dataset.surfaceType || null,
          grid_type: el.dataset.gridType || null,
          grid_kind: el.dataset.gridKind || null,

          sort_key: el.dataset.sortKey || null,
          sort_source: el.dataset.sortSource || null,

          page_type: el.dataset.pageType || document.body?.dataset?.pageType || null,
          page_slug: el.dataset.pageSlug || document.body?.dataset?.pageSlug || null,

          parent_collection_handle: el.dataset.parentCollectionHandle || null,
          parent_product_handle: el.dataset.parentProductHandle || null,
          parent_product_id: el.dataset.parentProductId || null,

          recommendation_source: el.dataset.recommendationSource || null,
          algorithm_version: el.dataset.algorithmVersion || null,
          nav_context: el.dataset.navContext || null,
          facet: el.dataset.facet || null,
          // Collection-nav card provenance: metafield | constructed
          source: el.dataset.source || null,

          // Colour identity (pill / swatch / active colour grid)
          target_hex: el.dataset.targetHex || el.dataset.colourTargetHex || null,

          // Search results / predictive context (forwarded from list wrappers)
          search_query: el.dataset.searchQuery || null,
          page_number:
            el.dataset.pageNumber != null && el.dataset.pageNumber !== ""
              ? Number(el.dataset.pageNumber)
              : null,
          position:
            el.dataset.position != null && el.dataset.position !== ""
              ? Number(el.dataset.position)
              : null,
          is_seed:
            el.dataset.isSeed === 'true'
              ? true
              : el.dataset.isSeed === 'false'
                ? false
                : null,

          ui_variant: el.dataset.uiVariant || null,
          ui_shape: el.dataset.uiShape || null,
          ui_media: el.dataset.uiMedia || null,
          ui_density: el.dataset.uiDensity || null,
          ui_size: el.dataset.uiSize || null,

          feature: el.dataset.feature || null,
          feature_rank:
            el.dataset.featureRank != null && el.dataset.featureRank !== ""
              ? Number(el.dataset.featureRank)
              : null,

          // ✅ FIX: propagate minted feature instance id into merged context
          feature_instance_id: el.dataset.featureInstanceId || null,

          collection_handle: el.dataset.collectionHandle || null,
          collection_id: el.dataset.collectionId || null,
          door_id: el.dataset.doorId || null,

          app_surface: el.dataset.appSurface || null,
          app_pitch: el.dataset.appPitch || null,
          device_os: el.dataset.deviceOs || null,
          is_in_app_browser:
            el.dataset.isInAppBrowser === 'true'
              ? true
              : el.dataset.isInAppBrowser === 'false'
                ? false
                : null
        };

        if (!opts.excludeProductIdentity) {
          ctx.product_id = el.dataset.productId || null;
          ctx.product_handle = el.dataset.productHandle || null;
        }

        return ctx;
      },

      getFeatureWrapperForEl: function (el) {
        if (!el) return document.body || null;
        return el.closest("[data-feature-context]") || el.closest("[data-feature]") || document.body || null;
      },

      // Deterministic list lookup:
      // - normal case: ancestor [data-list-instance-id]
      // - feature_viewed: list is inside the feature wrapper, so search descendants
      getListElForEl: function (el) {
        if (!el || el.nodeType !== 1) return null;

        const direct = el.closest("[data-list-instance-id]");
        if (direct) return direct;

        const wrapper = el.closest("[data-feature-context]") || el.closest("[data-feature]") || null;
        if (!wrapper || !wrapper.querySelector) return null;

        const list = wrapper.querySelector("[data-list-instance-id]");
        if (list) return list;

        // Fallback for modules that haven't minted list_instance_id yet:
        // treat the grid element as list context so grid_* etc populate
        return wrapper.querySelector("[data-grid-type]") || wrapper.querySelector(".collection__grid") || null;
      },

      ensureListInstanceIdOnEl: function (listEl) {
        if (!listEl || !listEl.dataset) return null;
        if (!listEl.dataset.listInstanceId) {
          listEl.dataset.listInstanceId = window.__fabTrackingHelpers.uuid();
        }
        return listEl.dataset.listInstanceId;
      },

      ensureFeatureInstanceIdOnEl: function (featureEl) {
        if (!featureEl) return null;
        if (!featureEl.dataset.featureInstanceId) {
          featureEl.dataset.featureInstanceId = "fi_" + window.__fabTrackingHelpers.uuid();
        }
        return featureEl.dataset.featureInstanceId;
      },

      getListInstanceIdForEl: function (el) {
        const listEl = window.__fabTrackingHelpers.getListElForEl(el);
        return listEl ? window.__fabTrackingHelpers.ensureListInstanceIdOnEl(listEl) : null;
      },

      // Correct merge semantics:
      // wrapper -> list -> element, but never allow null/"" to override defined values
      buildMergedContext: function (el, opts) {
        const h = window.__fabTrackingHelpers;

        const wrapperEl = h.getFeatureWrapperForEl(el);
        const listEl = h.getListElForEl(el);

        const wrapperCtx = h.buildContextFromEl(wrapperEl, opts);
        const listCtx = h.buildContextFromEl(listEl, opts);
        const elCtx = h.buildContextFromEl(el, opts);

        let ctx = h.mergePreferDefined({}, wrapperCtx);
        ctx = h.mergePreferDefined(ctx, listCtx);
        ctx = h.mergePreferDefined(ctx, elCtx);

        return ctx;
      },

      assignFeatureRanks: function () {
        const all = document.querySelectorAll("[data-feature]");
        all.forEach(function (el, i) {
          if (el.dataset.featureRank == null || el.dataset.featureRank === "") {
            el.dataset.featureRank = String(i);
          }
        });
      },

      notifyInjected: function (rootEl) {
        try {
          document.dispatchEvent(
            new CustomEvent("fab:tracking_injected", { detail: { root: rootEl || document } })
          );
        } catch (e) {}
      }
    };
  }

  // ============================================================
  // feature_viewed
  // ============================================================
  if (!window.__fabFeatureViewedInit) {
    window.__fabFeatureViewedInit = true;

    const start = performance.now();
    const seen = new Set();
    const MARGIN_PX = 40;
    let observer = null;

    function isReady() {
      return !!(window.posthog && typeof window.posthog.capture === "function");
    }

    function markSeen(el, feature) {
      const instanceId = window.__fabTrackingHelpers.ensureFeatureInstanceIdOnEl(el);
      const key = feature + ":" + instanceId;
      if (seen.has(key)) return null;
      seen.add(key);
      return instanceId;
    }

    function isInShrunkViewport(el) {
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (!vh) return false;

      const topBound = MARGIN_PX;
      const bottomBound = vh - MARGIN_PX;

      return r.bottom > topBound && r.top < bottomBound;
    }

    function fireIfEligible(el, entry) {
      const feature = el && el.dataset ? el.dataset.feature : null;
      if (!feature) return false;

      if (!isInShrunkViewport(el)) return false;
      if (!isReady()) return false;

      const instanceId = markSeen(el, feature);
      if (!instanceId) return true;

      const ctx = window.__fabTrackingHelpers.buildMergedContext(el);

      window.__fabTrackingHelpers.capture("feature_viewed", {
        feature,
        feature_instance_id: instanceId,
        view_method: "intersection_margin_px",
        time_to_view_ms: Math.round(performance.now() - start),
        intersection_ratio: entry && typeof entry.intersectionRatio === "number" ? entry.intersectionRatio : null,
        ...ctx
      });

      return true;
    }

    function ensureObserver() {
      if (observer) return;

      observer = new IntersectionObserver(
        function (entries) {
          for (const entry of entries) {
            const el = entry.target;
            if (!entry.isIntersecting) continue;

            if (fireIfEligible(el, entry)) {
              observer.unobserve(el);
            }
          }
        },
        {
          threshold: 0,
          rootMargin: `-${MARGIN_PX}px 0px -${MARGIN_PX}px 0px`
        }
      );
    }

    function observeFeatures(rootEl) {
      ensureObserver();
      const root = rootEl || document;

      const els = [];
      if (root.nodeType === 1 && root.matches && root.matches("[data-feature]")) els.push(root);

      const children = root.querySelectorAll ? root.querySelectorAll("[data-feature]") : [];
      children.forEach(el => els.push(el));

      els.forEach(function (el) {
        if (el.hidden) return;
        window.__fabTrackingHelpers.ensureFeatureInstanceIdOnEl(el);
        observer.observe(el);
      });

      els.forEach(function (el) {
        if (el.hidden) return;
        fireIfEligible(el, null);
      });
    }

    function init() {
      window.__fabTrackingHelpers.assignFeatureRanks();
      observeFeatures(document);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      setTimeout(init, 0);
    }

    document.addEventListener("fab:tracking_injected", function (ev) {
      window.__fabTrackingHelpers.assignFeatureRanks();
      const root = ev.detail && ev.detail.root ? ev.detail.root : document;
      observeFeatures(root);
    });

    window.__fabTrackingHelpers.observeFeatures = observeFeatures;
  }

  // ============================================================
  // clicked
  // ============================================================
  if (!window.__fabClickedInit) {
    window.__fabClickedInit = true;

    function parseSlot(x) {
      const n = Number.parseInt(x ?? "", 10);
      return Number.isFinite(n) ? n : null;
    }

    function handleClick(event) {
      if (!window.__fabTrackingHelpers.isPosthogReady()) return;

      const t = event.target;
      if (!t || t.nodeType !== 1) return;

      const el = t.closest("[data-track='click']");
      if (!el) return;

      const listEl = window.__fabTrackingHelpers.getListElForEl(el);
      const listInstanceId = listEl ? window.__fabTrackingHelpers.ensureListInstanceIdOnEl(listEl) : null;

      const slot = parseSlot(el.dataset.slot);
      const ctx = window.__fabTrackingHelpers.buildMergedContext(el);

      window.__fabTrackingHelpers.capture("clicked", {
        target_type: el.dataset.targetType || null,
        target_id: el.dataset.targetId || null,
        slot: slot,
        list_instance_id: listInstanceId,
        href: el.getAttribute("href") || null,
        ...ctx
      });
    }

    function init() {
      document.addEventListener("click", handleClick);
    }

    function scheduleInit() {
      if ("requestIdleCallback" in window) requestIdleCallback(init);
      else setTimeout(init, 0);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", scheduleInit);
    } else {
      scheduleInit();
    }
  }

  // ============================================================
  // changed
  // ============================================================
  if (!window.__fabChangedInit) {
    window.__fabChangedInit = true;

    function handleChange(event) {
      if (!window.__fabTrackingHelpers.isPosthogReady()) return;

      const t = event.target;
      if (!t || t.nodeType !== 1) return;

      const el = t.closest("[data-track='change']");
      if (!el) return;

      const changeType = el.dataset.changeType || null;

      const fromVal = el.dataset.from || null;
      let toVal = el.dataset.to || null;

      if (!toVal && "value" in el) {
        try {
          toVal = String(el.value);
        } catch (e) {}
      }

      const listInstanceId = window.__fabTrackingHelpers.getListInstanceIdForEl(el);
      const ctx = window.__fabTrackingHelpers.buildMergedContext(el);

      window.__fabTrackingHelpers.capture("changed", {
        change_type: changeType,
        from: fromVal,
        to: toVal,
        list_instance_id: listInstanceId,
        ...ctx
      });
    }

    function init() {
      document.addEventListener("change", handleChange, true);
      document.addEventListener("input", handleChange, true);
    }

    function scheduleInit() {
      if ("requestIdleCallback" in window) requestIdleCallback(init);
      else setTimeout(init, 0);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", scheduleInit);
    } else {
      scheduleInit();
    }
  }

  // ============================================================
  // collection_impression_batch
  // ✅ FIXES:
  // - mint + include feature_instance_id (even if feature_viewed hasn't fired yet)
  // - keep list_instance_id for batching mechanics
  // ============================================================
  if (!window.__fabCollectionImpressionInit) {
    window.__fabCollectionImpressionInit = true;

    const IMPRESSION_THRESHOLD = 0.5;
    const BATCH_SIZE = 12;
    const FLUSH_MS = 1000;

    let observer = null;
    const buffersByListId = new Map();
    const seenByListId = new Map();

    function ensureObserver() {
      if (observer) return;
      observer = new IntersectionObserver(onIntersect, {
        root: null,
        rootMargin: "0px",
        threshold: [IMPRESSION_THRESHOLD]
      });
    }

    function getSeenSet(listId) {
      let s = seenByListId.get(listId);
      if (!s) {
        s = new Set();
        seenByListId.set(listId, s);
      }
      return s;
    }

    function getBuffer(listId) {
      let b = buffersByListId.get(listId);
      if (!b) {
        // ✅ FIX: store featureInstanceId on the buffer
        b = { items: [], firstContext: null, flushTimer: null, featureInstanceId: null };
        buffersByListId.set(listId, b);
      }
      return b;
    }

    function scheduleFlush(listId) {
      const b = getBuffer(listId);
      if (b.flushTimer) return;
      b.flushTimer = setTimeout(function () {
        b.flushTimer = null;
        flush(listId);
      }, FLUSH_MS);
    }

    function flush(listId) {
      const b = getBuffer(listId);
      if (!b.items.length) return;

      if (!window.__fabTrackingHelpers.isPosthogReady()) {
        scheduleFlush(listId);
        return;
      }

      window.__fabTrackingHelpers.capture(
        "collection_impression_batch",
        Object.assign({}, b.firstContext || {}, {
          list_instance_id: listId,
          // ✅ FIX: include feature_instance_id
          feature_instance_id: b.featureInstanceId || null,
          items: b.items.slice()
        })
      );

      b.items = [];
      b.firstContext = null;
      b.featureInstanceId = null;
    }

    function onIntersect(entries) {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        if (entry.intersectionRatio < IMPRESSION_THRESHOLD) continue;

        const el = entry.target;

        // Faceted collection nav stacks panels; only the active facet should impress.
        const facetPanel = el.closest("[data-fcn-panel]");
        if (facetPanel && !facetPanel.classList.contains("is-active")) {
          continue;
        }

        // ✅ FIX: mint feature_instance_id from wrapper right now (don't depend on feature_viewed timing)
        const wrapperEl = window.__fabTrackingHelpers.getFeatureWrapperForEl(el);
        const featureInstanceId = wrapperEl
          ? window.__fabTrackingHelpers.ensureFeatureInstanceIdOnEl(wrapperEl)
          : null;

        const collectionId = el.dataset.collectionId;
        const collectionHandle = el.dataset.collectionHandle;
        if (!collectionId) {
          observer.unobserve(el);
          continue;
        }

        const slot = Number.parseInt(el.dataset.slot ?? "", 10);
        if (!Number.isFinite(slot)) {
          observer.unobserve(el);
          continue;
        }

        const listEl = el.closest("[data-list-instance-id]");
        const listId = window.__fabTrackingHelpers.ensureListInstanceIdOnEl(listEl);
        if (!listId) {
          observer.unobserve(el);
          continue;
        }

        const seenSet = getSeenSet(listId);
        if (seenSet.has(collectionId)) {
          observer.unobserve(el);
          continue;
        }
        seenSet.add(collectionId);

        const ctx = window.__fabTrackingHelpers.buildMergedContext(el, {
          excludeProductIdentity: true
        });

        const b = getBuffer(listId);
        if (!b.firstContext) b.firstContext = ctx;
        if (!b.featureInstanceId) b.featureInstanceId = featureInstanceId;

        b.items.push({
          collection_id: collectionId,
          collection_handle: collectionHandle,
          slot: slot
        });

        if (b.items.length >= BATCH_SIZE) flush(listId);
        else scheduleFlush(listId);

        observer.unobserve(el);
      }
    }

    function observeCollectionCards(rootEl) {
      ensureObserver();
      const root = rootEl || document;

      const lists = [];
      if (root.nodeType === 1 && root.matches && root.matches("[data-list-instance-id]")) {
        lists.push(root);
      }

      const childLists = root.querySelectorAll ? root.querySelectorAll("[data-list-instance-id]") : [];
      childLists.forEach(function (el) {
        lists.push(el);
      });

      if (!lists.length) return;

      lists.forEach(function (listEl) {
        const listId = window.__fabTrackingHelpers.ensureListInstanceIdOnEl(listEl);
        if (!listId) return;

        const cards = listEl.querySelectorAll("[data-impression-item='collection'][data-collection-id][data-slot]");
        cards.forEach(function (cardEl) {
          const facetPanel = cardEl.closest("[data-fcn-panel]");
          if (facetPanel && !facetPanel.classList.contains("is-active")) return;
          observer.observe(cardEl);
        });
      });
    }

    function flushAll() {
      for (const [listId] of buffersByListId) flush(listId);
    }

    function init() {
      observeCollectionCards(document);

      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") flushAll();
      });

      window.addEventListener("beforeunload", flushAll);
    }

    function scheduleInit() {
      if ("requestIdleCallback" in window) requestIdleCallback(init);
      else setTimeout(init, 0);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", scheduleInit);
    } else {
      scheduleInit();
    }

    document.addEventListener("fab:tracking_injected", function (ev) {
      observeCollectionCards(ev.detail && ev.detail.root ? ev.detail.root : document);
    });

    window.__fabTrackingHelpers.observeCollectionCards = observeCollectionCards;
    window.__fabTrackingHelpers.flushCollectionImpressions = flushAll;
  }

  // ============================================================
  // product_impression_batch (GENERIC, batched)
  // ✅ FIXES:
  // - mint + include feature_instance_id (even if feature_viewed hasn't fired yet)
  // - keep list_instance_id for batching mechanics
  // ============================================================
  if (!window.__fabImpressionTrackingInit) {
    window.__fabImpressionTrackingInit = true;

    const IMPRESSION_THRESHOLD = 0.5;
    const BATCH_SIZE = 20;
    const FLUSH_MS = 1000;

    let observer = null;

    const buffersByListId = new Map();
    const seenByListId = new Map();

    function ensureObserver() {
      if (observer) return;
      observer = new IntersectionObserver(onIntersect, {
        root: null,
        rootMargin: "0px",
        threshold: [IMPRESSION_THRESHOLD]
      });
    }

    function getSeenSet(listId) {
      let s = seenByListId.get(listId);
      if (!s) {
        s = new Set();
        seenByListId.set(listId, s);
      }
      return s;
    }

    function getBuffer(listId) {
      let b = buffersByListId.get(listId);
      if (!b) {
        // ✅ FIX: store featureInstanceId on the buffer
        b = { items: [], firstContext: null, flushTimer: null, featureInstanceId: null };
        buffersByListId.set(listId, b);
      }
      return b;
    }

    function scheduleFlush(listId) {
      const b = getBuffer(listId);
      if (b.flushTimer) return;
      b.flushTimer = setTimeout(function () {
        b.flushTimer = null;
        flush(listId);
      }, FLUSH_MS);
    }

    function flush(listId) {
      const b = getBuffer(listId);
      if (!b.items.length) return;

      if (!window.__fabTrackingHelpers.isPosthogReady()) {
        scheduleFlush(listId);
        return;
      }

      window.__fabTrackingHelpers.capture(
        "product_impression_batch",
        Object.assign({}, b.firstContext || {}, {
          list_instance_id: listId,
          // ✅ FIX: include feature_instance_id
          feature_instance_id: b.featureInstanceId || null,
          items: b.items.slice()
        })
      );

      b.items = [];
      b.firstContext = null;
      b.featureInstanceId = null;
    }

    function onIntersect(entries) {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        if (entry.intersectionRatio < IMPRESSION_THRESHOLD) continue;

        const el = entry.target;

        // ✅ FIX: mint feature_instance_id from wrapper right now (don't depend on feature_viewed timing)
        const wrapperEl = window.__fabTrackingHelpers.getFeatureWrapperForEl(el);
        const featureInstanceId = wrapperEl
          ? window.__fabTrackingHelpers.ensureFeatureInstanceIdOnEl(wrapperEl)
          : null;

        const productId = el.dataset.productId;
        if (!productId) {
          observer.unobserve(el);
          continue;
        }

        const slot = Number.parseInt(el.dataset.slot ?? "", 10);
        if (!Number.isFinite(slot)) {
          observer.unobserve(el);
          continue;
        }

        const listEl = el.closest("[data-list-instance-id]");
        const listId = window.__fabTrackingHelpers.ensureListInstanceIdOnEl(listEl);
        if (!listId) {
          observer.unobserve(el);
          continue;
        }

        const seenSet = getSeenSet(listId);
        const pid = String(productId);
        if (seenSet.has(pid)) {
          observer.unobserve(el);
          continue;
        }
        seenSet.add(pid);

        const ctx = window.__fabTrackingHelpers.buildMergedContext(el, {
          excludeProductIdentity: true
        });

        const b = getBuffer(listId);
        if (!b.firstContext) b.firstContext = ctx;
        if (!b.featureInstanceId) b.featureInstanceId = featureInstanceId;

        b.items.push({
          product_id: pid,
          slot: slot,
          position:
            el.dataset.position != null && el.dataset.position !== ""
              ? Number(el.dataset.position)
              : slot,
          is_seed: el.dataset.isSeed === "true"
        });

        if (b.items.length >= BATCH_SIZE) flush(listId);
        else scheduleFlush(listId);

        observer.unobserve(el);
      }
    }

    function observeGridCards(rootEl) {
      ensureObserver();
      const root = rootEl || document;

      const lists = [];

      if (root.nodeType === 1 && root.matches && root.matches("[data-list-instance-id]")) {
        lists.push(root);
      }

      const childLists = root.querySelectorAll ? root.querySelectorAll("[data-list-instance-id]") : [];
      childLists.forEach(function (el) {
        lists.push(el);
      });

      if (!lists.length) return;

      lists.forEach(function (listEl) {
        const listId = window.__fabTrackingHelpers.ensureListInstanceIdOnEl(listEl);
        if (!listId) return;

        const cards = listEl.querySelectorAll("[data-impression-item='product'][data-product-id][data-slot]");
        cards.forEach(function (cardEl) {
          observer.observe(cardEl);
        });
      });
    }

    function flushAll() {
      for (const [listId] of buffersByListId) flush(listId);
    }

    function init() {
      observeGridCards(document);

      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") flushAll();
      });

      window.addEventListener("beforeunload", flushAll);
    }

    function scheduleInit() {
      if ("requestIdleCallback" in window) requestIdleCallback(init);
      else setTimeout(init, 0);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", scheduleInit);
    } else {
      scheduleInit();
    }

    document.addEventListener("fab:tracking_injected", function (ev) {
      observeGridCards(ev.detail && ev.detail.root ? ev.detail.root : document);
    });

    window.__fabTrackingHelpers.observeGridCards = observeGridCards;
    window.__fabTrackingHelpers.flushImpressions = flushAll;
  }
})();

(function () {
  'use strict';

  if (window.FabPlatform) return;

  var FALLBACK = {
    os: 'other',
    isMobile: false,
    isIOS: false,
    canInstallApp: false,
    browser: 'other',
    isInAppBrowser: false,
    inAppBrowserName: null,
    supportsUniversalLinks: false
  };

  function detectInAppBrowser(ua) {
    if (/Instagram/i.test(ua)) return 'instagram';
    if (/FBAN|FBAV|Facebook/i.test(ua)) return 'facebook';
    if (/TikTok|musical_ly/i.test(ua)) return 'tiktok';
    if (/Pinterest/i.test(ua)) return 'pinterest';
    if (/LinkedInApp/i.test(ua)) return 'linkedin';
    return null;
  }

  function detectBrowser(ua) {
    if (/Firefox\//i.test(ua)) return 'firefox';
    if (/CriOS|Chrome\//i.test(ua) && !/Edg/i.test(ua)) return 'chrome';
    if (/Safari\//i.test(ua) && !/CriOS|Chrome|Chromium|Edg/i.test(ua)) return 'safari';
    return 'other';
  }

  function detect() {
    try {
      var ua = navigator.userAgent || '';
      var platform = navigator.platform || '';
      var maxTouchPoints = navigator.maxTouchPoints || 0;

      var isIPad =
        (platform === 'MacIntel' && maxTouchPoints > 1) ||
        /iPad/i.test(ua);
      var isIPhone = /iPhone|iPod/i.test(ua);
      var isIOS = isIPad || isIPhone;

      var os = 'other';
      if (isIPad) os = 'ipados';
      else if (isIPhone) os = 'ios';
      else if (/Android/i.test(ua)) os = 'android';
      else if (/Mac/i.test(platform) || /Macintosh/i.test(ua)) os = 'macos';
      else if (/Win/i.test(platform) || /Windows/i.test(ua)) os = 'windows';

      var inAppBrowserName = detectInAppBrowser(ua);
      var isInAppBrowser = inAppBrowserName !== null;

      return {
        os: os,
        isMobile: isIOS || /Android/i.test(ua) || /Mobile/i.test(ua),
        isIOS: isIOS,
        canInstallApp: isIOS,
        browser: detectBrowser(ua),
        isInAppBrowser: isInAppBrowser,
        inAppBrowserName: inAppBrowserName,
        supportsUniversalLinks: isIOS && !isInAppBrowser
      };
    } catch (e) {
      return Object.assign({}, FALLBACK);
    }
  }

  window.FabPlatform = detect();
})();

(function () {
  'use strict';

  if (window.FabAppLink) return;

  var MIRROR_SAFE_PATH = /^\/$|^\/products\/[^/?#]+\/?$|^\/collections\/[^/?#]+\/?$/;
  var MAX_URL_LEN = 2048;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var CLICK_KEYS = ['fbclid', 'gclid', 'ttclid'];

  function getConfig() {
    return window.FabAppConfig || {};
  }

  function appStoreURL() {
    try {
      var url = getConfig().appStoreUrl;
      return url && String(url).trim() ? String(url).trim() : '';
    } catch (e) {
      return '';
    }
  }

  function getDeeplinkDomain() {
    try {
      var domain = getConfig().deeplinkDomain || 'https://fab-art.chottu.link';
      return String(domain).trim().replace(/\/+$/, '');
    } catch (e) {
      return 'https://fab-art.chottu.link';
    }
  }

  function normalizePath(path) {
    var normalized = path == null || path === '' ? '/' : String(path);
    normalized = normalized.split('?')[0].split('#')[0];
    if (normalized.charAt(0) !== '/') normalized = '/' + normalized;
    if (normalized.length > 1 && normalized.charAt(normalized.length - 1) === '/') {
      normalized = normalized.slice(0, -1);
    }
    return normalized;
  }

  function defaultPath() {
    try {
      var pathname = normalizePath(window.location && window.location.pathname);

      if (isMirrorSafePath(pathname)) return pathname;

      var body = document.body;
      var pageType = body && body.dataset ? body.dataset.pageType : null;
      var pageSlug = body && body.dataset ? body.dataset.pageSlug : null;

      if (pageType === 'pdp' && pageSlug) return '/products/' + pageSlug;
      if (pageType === 'plp' && pageSlug) return '/collections/' + pageSlug;
      if (pageType === 'home') return '/';

      var stripped = pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/(?:products|collections)\/)/i, '');
      if (stripped !== pathname && isMirrorSafePath(stripped)) return stripped;

      return pathname;
    } catch (e) {
      return '/';
    }
  }

  function isMirrorSafePath(path) {
    return MIRROR_SAFE_PATH.test(path);
  }

  function readTouchAttribution() {
    try {
      if (window.__fabTouchAttribution && typeof window.__fabTouchAttribution.getTouch === 'function') {
        return window.__fabTouchAttribution.getTouch();
      }
    } catch (e) {}
    return null;
  }

  function readSearchParams() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (e) {
      return null;
    }
  }

  function pickValue(touch, searchParams, key) {
    if (touch && touch[key]) return String(touch[key]);
    if (searchParams) {
      var fromSearch = searchParams.get(key);
      if (fromSearch) return fromSearch;
    }
    return null;
  }

  function buildAttributionEntries(options) {
    options = options || {};
    var touch = readTouchAttribution();
    var searchParams = readSearchParams();
    var entries = [];

    UTM_KEYS.forEach(function (key) {
      var value = pickValue(touch, searchParams, key);
      if (value) entries.push({ key: key, value: value, truncatable: key === 'utm_content' || key === 'utm_term' });
    });

    CLICK_KEYS.forEach(function (key) {
      var value = touch && touch[key] ? String(touch[key]) : null;
      if (value) entries.push({ key: key, value: value, truncatable: false });
    });

    if (options.w2aSource) {
      entries.push({ key: 'w2a_source', value: String(options.w2aSource), truncatable: false });
    }
    if (options.w2aMedium) {
      entries.push({ key: 'w2a_medium', value: String(options.w2aMedium), truncatable: false });
    }
    if (options.w2aCampaign) {
      entries.push({ key: 'w2a_campaign', value: String(options.w2aCampaign), truncatable: false });
    }

    return entries;
  }

  function entriesToQuery(entries) {
    return entries.map(function (entry) {
      return entry.key + '=' + encodeURIComponent(entry.value);
    });
  }

  function enforceMaxUrlLength(domain, path, coreQuery, attributionEntries) {
    function buildUrl(entries) {
      var query = coreQuery.concat(entriesToQuery(entries));
      return domain + path + '?' + query.join('&') + '&_ch_incp=1';
    }

    var url = buildUrl(attributionEntries);
    if (url.length <= MAX_URL_LEN) return url;

    var mutable = attributionEntries.map(function (entry) {
      return {
        key: entry.key,
        value: entry.value,
        truncatable: entry.truncatable
      };
    });

    var truncatable = mutable.filter(function (entry) {
      return entry.truncatable;
    });

    while (url.length > MAX_URL_LEN && truncatable.length) {
      var target = truncatable.shift();
      var idx = -1;
      for (var i = 0; i < mutable.length; i++) {
        if (mutable[i].key === target.key) {
          idx = i;
          break;
        }
      }
      if (idx === -1) continue;

      if (mutable[idx].value.length <= 8) {
        mutable.splice(idx, 1);
      } else {
        mutable[idx].value = mutable[idx].value.slice(0, Math.max(8, mutable[idx].value.length - 32));
      }

      url = buildUrl(mutable);
    }

    if (url.length > MAX_URL_LEN) {
      return url.slice(0, MAX_URL_LEN);
    }

    return url;
  }

  function assembleUrl(domain, path, surface, pitch, anonId, options) {
    options = options || {};
    var coreQuery = [];

    if (surface) coreQuery.push('src=' + encodeURIComponent(String(surface)));
    if (pitch) coreQuery.push('pitch=' + encodeURIComponent(String(pitch)));
    if (anonId) coreQuery.push('fab_anon_id=' + encodeURIComponent(String(anonId)));

    var attributionEntries = buildAttributionEntries(options);
    return enforceMaxUrlLength(domain, path, coreQuery, attributionEntries);
  }

  function resolvePitch(options, path) {
    if (options.pitch) return options.pitch;
    if (options.surface === 'pdp') return 'ar';
    if (/^\/products\/[^/?#]+\/?$/.test(path)) return 'ar';
    return null;
  }

  function build(options) {
    options = options || {};

    try {
      var fallback = appStoreURL();
      var path = normalizePath(options.path != null ? options.path : defaultPath());
      var pitch = resolvePitch(options, path);

      if (!isMirrorSafePath(path)) {
        return fallback;
      }

      var anonId = null;
      try {
        if (window.__fab_anon_id) anonId = String(window.__fab_anon_id);
      } catch (e) {}

      return assembleUrl(getDeeplinkDomain(), path, options.surface || null, pitch, anonId, options);
    } catch (e) {
      return appStoreURL();
    }
  }

  window.FabAppLink = {
    build: build,
    appStoreURL: appStoreURL,
    hasInstallHint: hasInstallHint,
    markInstallHint: markInstallHint,
    resolveIosHandoff: resolveIosHandoff,
    watchDeeplinkOpen: watchDeeplinkOpen
  };

  function hasInstallHint() {
    try {
      return localStorage.getItem('fab_app_install_hint') === '1';
    } catch (e) {
      return false;
    }
  }

  function markInstallHint() {
    try {
      localStorage.setItem('fab_app_install_hint', '1');
    } catch (e) {}
  }

  function initInstallHintFromQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('fab_from_app') === '1' || params.get('fab_app_installed') === '1') {
        markInstallHint();
      }
    } catch (e) {}
  }

  /**
   * iOS handoff CTA: default to App Store install unless we have a hint the app
   * was opened before (localStorage or ?fab_from_app=1). Safari cannot read install state.
   */
  function handoffLabel(key, fallback) {
    var strings = (getConfig().strings) || {};
    var short = key.indexOf('.') >= 0 ? key.slice(key.indexOf('.') + 1) : key;
    var value = strings[short];
    return typeof value === 'string' && value !== '' ? value : fallback;
  }

  function resolveIosHandoff(options) {
    options = options || {};
    var deeplink = options.deeplink || '';
    var store = appStoreURL();
    var deeplinkValid = !!(deeplink && deeplink.indexOf('_ch_incp=1') !== -1);
    var preferOpen = hasInstallHint() && deeplinkValid;

    if (preferOpen) {
      return {
        href: deeplink,
        mode: 'open',
        label: handoffLabel('app.open', 'Open in the app'),
        targetId: 'app_open',
        showAppleIcon: false
      };
    }

    if (store) {
      return {
        href: store,
        mode: 'install',
        label: handoffLabel('app.download', 'Download the app'),
        targetId: 'app_install',
        showAppleIcon: true
      };
    }

    if (deeplinkValid) {
      return {
        href: deeplink,
        mode: 'open',
        label: handoffLabel('app.open', 'Open in the app'),
        targetId: 'app_open',
        showAppleIcon: false
      };
    }

    return null;
  }

  function watchDeeplinkOpen() {
    var done = false;

    function finish() {
      if (done) return;
      done = true;
      cleanup();
      markInstallHint();
    }

    function onVis() {
      if (document.visibilityState === 'hidden') finish();
    }

    function cleanup() {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVis);
    }

    document.addEventListener('visibilitychange', onVis);
    var timer = setTimeout(cleanup, 2500);
  }

  initInstallHintFromQuery();
})();

(function () {
  'use strict';

  if (window.FabAppTrack) return;

  function context(overrides) {
    overrides = overrides || {};

    try {
      var platform = window.FabPlatform || {};
      var dataset = (document.body && document.body.dataset) || {};

      return {
        app_surface: overrides.app_surface != null ? overrides.app_surface : overrides.surface || null,
        app_pitch: overrides.app_pitch != null ? overrides.app_pitch : overrides.pitch || null,
        device_os: platform.os || 'other',
        is_in_app_browser: !!platform.isInAppBrowser,
        page_type: dataset.pageType || null,
        page_slug: dataset.pageSlug || null
      };
    } catch (e) {
      return {
        app_surface: null,
        app_pitch: null,
        device_os: 'other',
        is_in_app_browser: false,
        page_type: null,
        page_slug: null
      };
    }
  }

  window.FabAppTrack = {
    context: context
  };
})();

/* Fab Wishlist — v2 · 9 May 2026
   Complete drop-in replacement for fab-wishlist.js.

   Fixes in this version:
   - Shared wishlist cards have wishlist hearts so visitors can save items
   - Share link points to /pages/shared-wishlist (separate page)
   - Anyone can share (not gated to signed-in)
   - Empty state leads with sign-in prompt, same banner style
   - Products load after sign-in without requiring a page refresh
   - Desktop share = clipboard only ("Link copied" toast), mobile = Web Share API
   - Guest banner redesigned: Register button, sign-in text link, share button
*/

(function () {
  'use strict';

  if (window.FabWishlist) return;

  // ---------------- constants ----------------

  const STORAGE_KEY = 'fab.wishlist.v1';
  const MIGRATION_FLAG = 'fab.wishlist.migrated.v1';
  const TOAST_DURATION_MS = 2000;
  const SYNC_DEBOUNCE_MS = 1500;
  const SYNC_ENDPOINT = '/apps/wishlist-sync';

  const SHOPIFY_DOMAIN =
    (window.Shopify && window.Shopify.shop) || '6433cd-5.myshopify.com';
  const STOREFRONT_TOKEN = window.FabStorefrontToken || null;
  const STOREFRONT_API_VERSION = '2025-01';
  const STOREFRONT_BATCH_SIZE = 250;

  // ---------------- utilities ----------------

  const _strId = (v) => (v == null ? null : String(v));

  const itemKey = (productId, variantId) =>
    variantId ? `${productId}:${variantId}` : `${productId}`;

  const sameItem = (a, b) =>
    _strId(a.productId) === _strId(b.productId) &&
    _strId(a.variantId || null) === _strId(b.variantId || null);

  function isMobile() {
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) || window.innerWidth < 768;
  }

  /** Localised copy, minted by snippets/fab-wishlist-strings.liquid. */
  let wishlistStrings;
  function readWishlistStrings() {
    if (wishlistStrings) return wishlistStrings;
    const el = document.querySelector('[data-fab-wishlist-strings]');
    try {
      wishlistStrings = el ? JSON.parse(el.textContent || '{}') : {};
    } catch (_) {
      wishlistStrings = {};
    }
    return wishlistStrings;
  }
  const t = (key, fallback) => {
    const map = readWishlistStrings();
    const short = key.indexOf('.') >= 0 ? key.slice(key.indexOf('.') + 1) : key;
    const value = map[short];
    return typeof value === 'string' && value !== '' ? value : fallback;
  };

  const savedCountLabel = (n) =>
    n === 1
      ? t('wishlist.saved_count_one', '1 item saved')
      : t('wishlist.saved_count_other', '{count} items saved').replace('{count}', String(n));

  /** Prefixes a root-relative path with the market locale root ('' on the primary locale). */
  const path = (p) => (window.fabPath ? window.fabPath(p) : p);

  const routes = () => window.FabRoutes || {};

  /** Rebuilds from the handle where possible, so stored URLs from another market can't leak through. */
  function productUrl(meta) {
    if (meta && meta.handle) return path(`/products/${meta.handle}`);
    let url = (meta && meta.url) || '';
    if (!url) return '#';
    if (/^https?:\/\//i.test(url)) return url;
    if (url.charAt(0) !== '/') url = '/' + url;
    return path(url);
  }

  const wishlistPath = () => routes().wishlist || path('/pages/wishlist');

  function loginUrlWithReturn() {
    return '/customer_authentication/login?return_to=' + encodeURIComponent(wishlistPath());
  }

  /** Set once the Storefront API rejects our @inContext language, so we stop retrying it. */
  let languageContextRejected = false;

  /** Storefront language for @inContext, so wishlist cards match the page they sit on. */
  function storefrontLanguage() {
    const raw =
      (window.Shopify && window.Shopify.locale) ||
      document.documentElement.lang ||
      'en';
    return String(raw).split('-')[0].toUpperCase();
  }

  // ---------------- store ----------------

  function createStore() {
    let state = loadFromStorage();
    const subscribers = new Set();
    let syncTimer = null;
    let customerSession = null;

    function loadFromStorage() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return defaultState();
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return defaultState();
        if (parsed.version !== 1) return defaultState();
        return {
          version: 1,
          items: Array.isArray(parsed.items) ? parsed.items : [],
          metaCache: parsed.metaCache && typeof parsed.metaCache === 'object'
            ? parsed.metaCache : {},
          updatedAt: parsed.updatedAt || Date.now(),
        };
      } catch (_) {
        return defaultState();
      }
    }

    function defaultState() {
      return { version: 1, items: [], metaCache: {}, updatedAt: Date.now() };
    }

    function persist() {
      try {
        state.updatedAt = Date.now();
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (_) {}
    }

    function broadcast() {
      subscribers.forEach((fn) => {
        try { fn(state); } catch (_) {}
      });
      try {
        window.dispatchEvent(new CustomEvent('fab-wishlist:change', {
          detail: { count: state.items.length, items: state.items.slice() },
        }));
      } catch (_) {}
    }

    function scheduleSync() {
      if (!customerSession) return;
      clearTimeout(syncTimer);
      syncTimer = setTimeout(() => syncToServer(), SYNC_DEBOUNCE_MS);
    }

    async function syncToServer() {
      if (!customerSession) return;
      try {
        const res = await fetch(SYNC_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: state.items.map((it) => ({
              productId: it.productId,
              variantId: it.variantId || null,
            })),
          }),
        });
        if (!res.ok) console.warn('[fab-wishlist] sync failed', res.status);
      } catch (err) {
        console.warn('[fab-wishlist] sync error', err);
      }
    }

    function loadFromCustomerSession() {
      if (!customerSession?.wishlist) return [];
      const data = customerSession.wishlist;
      // Handle both string (from Liquid json filter) and object
      let parsed = data;
      if (typeof data === 'string') {
        try { parsed = JSON.parse(data); } catch (_) { return []; }
      }
      const items = parsed.items || parsed;
      if (!Array.isArray(items)) return [];
      return items.map((it) => ({
        productId: it.productId || it.p,
        variantId: it.variantId || it.v || undefined,
      }));
    }

    // ---------- public API ----------

    function has(productId, variantId) {
      const target = { productId, variantId: variantId || undefined };
      return state.items.some((it) => sameItem(it, target));
    }

    function hasProduct(productId) {
      return state.items.some((it) => _strId(it.productId) === _strId(productId));
    }

    function add(item) {
      if (!item || item.productId == null) return false;
      const target = {
        productId: item.productId,
        variantId: item.variantId || undefined,
      };
      if (state.items.some((it) => sameItem(it, target))) return false;
      state.items.push(target);
      const metaFields = {};
      if (item.title) metaFields.title = item.title;
      if (item.image) metaFields.image = item.image;
      if (item.imageAlt) metaFields.imageAlt = item.imageAlt;
      if (item.handle) metaFields.handle = item.handle;
      if (item.price != null) metaFields.price = item.price;
      if (item.priceCompare != null) metaFields.priceCompare = item.priceCompare;
      if (item.currency) metaFields.currency = item.currency;
      if (item.url) metaFields.url = item.url;
      if (Object.keys(metaFields).length) {
        state.metaCache[String(item.productId)] = {
          ...(state.metaCache[String(item.productId)] || {}),
          ...metaFields,
          cachedAt: Date.now(),
        };
      }
      persist();
      scheduleSync();
      broadcast();
      return true;
    }

    function remove(productId, variantId) {
      const before = state.items.length;
      const target = { productId, variantId: variantId || undefined };
      state.items = state.items.filter((it) => !sameItem(it, target));
      if (state.items.length === before) return false;
      if (!hasProduct(productId)) {
        delete state.metaCache[String(productId)];
      }
      persist();
      scheduleSync();
      broadcast();
      return true;
    }

    function toggle(item) {
      if (has(item.productId, item.variantId)) {
        return { added: false, removed: remove(item.productId, item.variantId) };
      }
      return { added: add(item), removed: false };
    }

    function getItems() { return state.items.slice(); }
    function getMeta(productId) { return state.metaCache[String(productId)]; }

    function subscribe(fn) {
      subscribers.add(fn);
      try { fn(state); } catch (_) {}
      return () => subscribers.delete(fn);
    }

    function signIn(session) {
      customerSession = session;
      // Fetch live wishlist from server (not from Liquid cache which may be stale)
      _fetchAndMergeFromServer();
    }
    async function _fetchAndMergeFromServer() {
      try {
        const res = await fetch(SYNC_ENDPOINT + '?_t=' + Date.now(), { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        const serverItems = data?.wishlist?.items || [];

        if (serverItems.length === 0 && state.items.length > 0) {
          syncToServer();
          _refreshMetaCacheIfNeeded();
          return;
        }

        state.items = serverItems;
        persist();
        broadcast();

        // Track successful sign-in with wishlist sync
        try {
          if (window.__fabTrackingHelpers && window.__fabTrackingHelpers.capture) {
            window.__fabTrackingHelpers.capture('wishlist_signin_completed', {
              wishlist_count: state.items.length,
              server_items: serverItems.length,
              source: 'wishlist_sync'
            });
          }
        } catch (_) {}

        _refreshMetaCacheIfNeeded();
      } catch (err) {
        console.warn('[fab-wishlist] fetch from server failed', err);
        _refreshMetaCacheIfNeeded();
      }
    }
    
    function signOut() { customerSession = null; }

    function clear() {
      state = defaultState();
      persist();
      scheduleSync();
      broadcast();
    }

    function updateMeta(productId, meta) {
      const key = String(productId);
      state.metaCache[key] = {
        ...(state.metaCache[key] || {}),
        ...meta,
        cachedAt: Date.now(),
      };
    }

    function persistAndBroadcast() { persist(); broadcast(); }

    // Fetch metadata for any items missing from metaCache
    async function _refreshMetaCacheIfNeeded() {
      const missing = state.items.filter((it) => !state.metaCache[String(it.productId)]);
      if (!missing.length) return;
      const country = (window.Shopify?.country || 'GB').toUpperCase();
      const fresh = await fetchProductsFromStorefront(missing, country);
      if (!fresh || !fresh.size) return;
      fresh.forEach((meta, productId) => { updateMeta(productId, meta); });
      persistAndBroadcast();
    }

    return {
      has, hasProduct, add, remove, toggle, getItems, getMeta,
      subscribe, signIn, signOut, clear, updateMeta, persistAndBroadcast,
      _save: persist, _notify: broadcast, _refreshMetaCacheIfNeeded,
      get count() { return state.items.length; },
      get state() { return state; },
    };
  }

  const store = createStore();

  // ---------------- Storefront API helper ----------------

  async function fetchProductsFromStorefront(items, country) {
    if (!STOREFRONT_TOKEN) {
      console.warn('[fab-wishlist] No Storefront API token configured');
      return null;
    }
    if (!items.length) return new Map();

    const uniqueIds = Array.from(new Set(items.map((it) => String(it.productId))));

    const buildQuery = (withLanguage) => `
      query Wishlist($ids: [ID!]!, $country: CountryCode!${withLanguage ? ', $language: LanguageCode!' : ''})
        @inContext(country: $country${withLanguage ? ', language: $language' : ''}) {
        nodes(ids: $ids) {
          ... on Product {
            id handle title availableForSale
            featuredImage { url altText }
            priceRange { minVariantPrice { amount currencyCode } }
            compareAtPriceRange { minVariantPrice { amount currencyCode } }
          }
        }
      }
    `;

    const language = storefrontLanguage();
    const post = (query, variables) =>
      fetch(`https://${SHOPIFY_DOMAIN}/api/${STOREFRONT_API_VERSION}/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query, variables }),
      });

    const result = new Map();

    for (let i = 0; i < uniqueIds.length; i += STOREFRONT_BATCH_SIZE) {
      const chunk = uniqueIds.slice(i, i + STOREFRONT_BATCH_SIZE);
      const gids = chunk.map((id) => `gid://shopify/Product/${id}`);

      let nodes;
      try {
        let res;
        let json = null;

        if (!languageContextRejected) {
          res = await post(buildQuery(true), { ids: gids, country, language });
          json = res.ok ? await res.json() : null;
          if (!json || json.errors) languageContextRejected = true;
        }

        // Unpublished languages are rejected outright; fall back to shop default.
        if (languageContextRejected) {
          res = await post(buildQuery(false), { ids: gids, country });
          if (!res.ok) { console.warn('[fab-wishlist] Storefront fetch failed', res.status); return null; }
          json = await res.json();
        }
        if (json.errors) { console.warn('[fab-wishlist] Storefront errors', json.errors); return null; }
        nodes = json?.data?.nodes;
        if (!Array.isArray(nodes)) return null;
      } catch (err) {
        console.warn('[fab-wishlist] Storefront fetch error', err);
        return null;
      }

      nodes.forEach((p) => {
        if (!p || !p.id) return;
        const match = String(p.id).match(/Product\/(\d+)/);
        if (!match) return;
        const productId = match[1];
        const minAmount = parseFloat(p.priceRange?.minVariantPrice?.amount);
        const minCompare = parseFloat(p.compareAtPriceRange?.minVariantPrice?.amount);

        result.set(productId, {
          title: p.title, handle: p.handle, url: path(`/products/${p.handle}`),
          image: p.featuredImage?.url, imageAlt: p.featuredImage?.altText || p.title,
          price: Number.isFinite(minAmount) ? Math.round(minAmount * 100) : undefined,
          priceCompare: Number.isFinite(minCompare) && minCompare > minAmount
            ? Math.round(minCompare * 100) : undefined,
          currency: p.priceRange?.minVariantPrice?.currencyCode,
          available: !!p.availableForSale,
        });
      });
    }

    return result;
  }

  // ---------------- migration from Wishlist King ----------------

  async function migrate() {
    try {
      if (localStorage.getItem(MIGRATION_FLAG) === '1') return;
      const candidates = [];

      if (typeof caches !== 'undefined' && caches.keys) {
        try {
          const cacheNames = await caches.keys();
          const wkCacheNames = cacheNames.filter((n) => /^wk-wishlist/i.test(n));
          for (const cacheName of wkCacheNames) {
            const cache = await caches.open(cacheName);
            const requests = await cache.keys();
            for (const req of requests) {
              if (!/wishlists(\/|%2F)mine/i.test(req.url)) continue;
              try {
                let res = await cache.match(req);
                if (!res) res = await cache.match(req.url);
                if (!res) res = await cache.match(req.url, { ignoreVary: true, ignoreSearch: true });
                if (!res) continue;
                let data;
                try { data = await res.json(); } catch (_) {
                  try { const txt = await res.clone().text(); if (!txt || !txt.trim()) continue; data = JSON.parse(txt); } catch (_) { continue; }
                }
                const items = data?.value?.wishlist?.items || data?.wishlist?.items || data?.items || data?.data?.items || (Array.isArray(data) ? data : null);
                if (Array.isArray(items) && items.length) candidates.push(items);
              } catch (_) {}
            }
          }
        } catch (_) {}
      }

      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (!k) continue;
        if (/^(wk_|wishlist[_-]?king|WishlistKing)/i.test(k)) {
          try {
            const parsed = JSON.parse(localStorage.getItem(k));
            const items = parsed?.value?.wishlist?.items || parsed?.items;
            if (Array.isArray(items)) candidates.push(items);
          } catch (_) {}
        }
      }

      const wk = window.WishlistKing || window.wk || null;
      if (wk?.app?.apis?.storefront?.wishlist?.items) {
        candidates.push(wk.app.apis.storefront.wishlist.items);
      }

      if (!candidates.length) {
        try { localStorage.removeItem('wk_session_id'); } catch (_) {}
        localStorage.setItem(MIGRATION_FLAG, '1');
        return;
      }

      candidates.sort((a, b) => b.length - a.length);
      const flat = candidates[0]
        .map((it) => ({
          productId: it.productId || it.product_id || it.id,
          variantId: it.variantId || it.variant_id || undefined,
          title: it.title || it.product_title || undefined,
          image: it.image || it.featured_image || undefined,
          handle: it.handle || it.product_handle || undefined,
        }))
        .filter((it) => it.productId != null && !/^[a-f0-9]{24}$/i.test(String(it.productId)));

      let imported = 0;
      flat.forEach((it) => { if (store.add(it)) imported++; });

      try { localStorage.removeItem('wk_session_id'); } catch (_) {}
      localStorage.setItem(MIGRATION_FLAG, '1');

      if (imported > 0) {
        console.info(`[fab-wishlist] Migrated ${imported} item(s) from previous wishlist.`);
        try { window.dispatchEvent(new CustomEvent('fab-wishlist:migrated', { detail: { count: imported } })); } catch (_) {}
      }
    } catch (err) {
      console.warn('[fab-wishlist] Migration failed', err);
    }
  }

  // ---------------- toast ----------------

  let toastEl = null;
  let toastTimer = null;
  let pendingUndo = null;

  function showToast(message, undoFn) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fab-wishlist-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    pendingUndo = undoFn || null;
    toastEl.innerHTML = '';
    const msg = document.createElement('span');
    msg.className = 'fab-wishlist-toast__message';
    msg.textContent = message;
    toastEl.appendChild(msg);
    if (undoFn) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fab-wishlist-toast__undo';
      btn.textContent = t('wishlist.undo', 'Undo');
      btn.addEventListener('click', () => {
        if (pendingUndo) { pendingUndo(); pendingUndo = null; }
        hideToast();
      });
      toastEl.appendChild(btn);
    }
    toastEl.offsetHeight;
    toastEl.classList.add('fab-wishlist-toast--visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, TOAST_DURATION_MS);
  }

  function hideToast() {
    if (!toastEl) return;
    toastEl.classList.remove('fab-wishlist-toast--visible');
    pendingUndo = null;
  }

// ---------------- enhanced sign-up toast ----------------
function showSignupToast(productId, variantId) {
  hideToast();

  var loginUrl = window.FabLoginUrl || '/customer_authentication/login';

  var el = document.createElement('div');
  el.className = 'fab-wishlist-toast fab-wishlist-toast--signup';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.innerHTML =
    '<div class="fab-wishlist-toast__signup-content">' +
      '<span class="fab-wishlist-toast__message">\u2713 ' + escapeText(t('wishlist.added', 'Added to wishlist')) + '</span>' +
      '<span class="fab-wishlist-toast__signup-body"><strong>' + escapeText(savedCountLabel(store.count)) + '</strong> \u00b7 ' + escapeText(t('wishlist.sync_prompt', 'Sign in to sync across devices')) + '</span>' +
      '<div class="fab-wishlist-toast__signup-actions">' +
        '<a href="' + escapeAttr(loginUrl) + '" class="fab-wishlist-toast__signup-btn">' + escapeText(t('wishlist.signup_or_signin', 'Sign up or sign in')) + '</a>' +
        '<button type="button" class="fab-wishlist-toast__signup-dismiss">' + escapeText(t('wishlist.not_now', 'Not now')) + '</button>' +
      '</div>' +
    '</div>';

  // Track "Save to account" click
  el.querySelector('.fab-wishlist-toast__signup-btn').addEventListener('click', function () {
    try {
      if (window.__fabTrackingHelpers && window.__fabTrackingHelpers.capture) {
        window.__fabTrackingHelpers.capture('wishlist_signup_toast_clicked', {
          wishlist_count: store.count,
          page_type: document.body.dataset.pageType || null,
          path: window.location.pathname
        });
      }
    } catch (_) {}
  });

  // "Not now" dismisses and suppresses for this session
  el.querySelector('.fab-wishlist-toast__signup-dismiss').addEventListener('click', function () {
    sessionStorage.setItem('fab.wishlist.signup_dismissed', '1');
    try {
      if (window.__fabTrackingHelpers && window.__fabTrackingHelpers.capture) {
        window.__fabTrackingHelpers.capture('wishlist_signup_toast_dismissed', {
          wishlist_count: store.count,
          page_type: document.body.dataset.pageType || null,
          path: window.location.pathname
        });
      }
    } catch (_) {}
    el.classList.remove('fab-wishlist-toast--visible');
    setTimeout(function () { el.remove(); }, 300);
  });

  document.body.appendChild(el);
  el.offsetHeight;

  // Track toast impression
  try {
    if (window.__fabTrackingHelpers && window.__fabTrackingHelpers.capture) {
      window.__fabTrackingHelpers.capture('wishlist_signup_toast_shown', {
        wishlist_count: store.count,
        page_type: document.body.dataset.pageType || null,
        path: window.location.pathname
      });
    }
  } catch (_) {}

  el.classList.add('fab-wishlist-toast--visible');

  setTimeout(function () {
    el.classList.remove('fab-wishlist-toast--visible');
    setTimeout(function () { el.remove(); }, 300);
  }, 6000);
}
  // ---------------- <wishlist-button> ----------------

  class WishlistButton extends HTMLElement {
    constructor() { super(); this._unsubscribe = null; this._render = this._render.bind(this); this._onClick = this._onClick.bind(this); }

    connectedCallback() {
      if (!this._built) { this._build(); this._built = true; }
      this._unsubscribe = store.subscribe(this._render);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() { this._unsubscribe?.(); this.removeEventListener('click', this._onClick); }
    static get observedAttributes() { return ['data-product-id', 'data-variant-id']; }
    attributeChangedCallback() { if (this._built) this._render(); }

    _build() {
      this.classList.add('fab-wishlist-btn');
      this.setAttribute('type', 'button');
      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
      if (!this.querySelector('.fab-wishlist-btn__icon')) {
        this.innerHTML = `
          <span class="fab-wishlist-btn__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" class="fab-wishlist-btn__svg" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 21s-7.5-4.7-9.6-9.3C.7 7.7 3.5 4 7.2 4c2 0 3.5 1 4.8 2.6C13.3 5 14.8 4 16.8 4c3.7 0 6.5 3.7 4.8 7.7C19.5 16.3 12 21 12 21z"/>
            </svg>
          </span>
        `;
      }
    }

    _onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      const productId = this.getAttribute('data-product-id');
      if (!productId) return;
      const variantId = this.getAttribute('data-variant-id') || undefined;

      this.classList.add('fab-wishlist-btn--pulse');
      setTimeout(() => this.classList.remove('fab-wishlist-btn--pulse'), 320);

      const isFilled = variantId
        ? store.has(productId, variantId) || store.hasProduct(productId)
        : store.hasProduct(productId);

      if (isFilled) {
        const removedItems = store.getItems().filter((it) => String(it.productId) === String(productId));
        const meta = store.getMeta(productId);
        removedItems.forEach((it) => store.remove(it.productId, it.variantId));
        showToast(t('wishlist.removed', 'Removed from wishlist'), () => { removedItems.forEach((it) => { store.add({ ...it, ...(meta || {}) }); }); });
      } else {
        const item = this._collectItemMetadata(productId, variantId);
        store.add(item);

        // Enhanced toast for guests on 3rd+ add
        if (!window.FabCustomerSession
            && store.count >= 3
            && !sessionStorage.getItem('fab.wishlist.signup_dismissed')) {
          showSignupToast(productId, variantId);
        } else {
          showToast(t('wishlist.added', 'Added to wishlist'), () => store.remove(productId, variantId));
        }
      }

      try { window.dispatchEvent(new CustomEvent('fab-wishlist:toggle', { detail: { productId, variantId, added: !isFilled } })); } catch (_) {}
    }

    _collectItemMetadata(productId, variantId) {
      const item = { productId, variantId };
      const direct = (k) => this.getAttribute('data-' + k);
      item.title = direct('product-title') || undefined;
      item.image = direct('product-image') || undefined;
      item.handle = direct('product-handle') || undefined;
      item.url = direct('product-url') || undefined;
      const price = direct('product-price');
      if (price != null && price !== '') item.price = Number(price);
      const cmp = direct('product-price-compare');
      if (cmp != null && cmp !== '') item.priceCompare = Number(cmp);
      if (!item.title || !item.image || !item.handle) {
        const card = this.closest('[data-product-card], [data-fab-product-card], product-info, .product-card, .card');
        if (card) {
          item.title ??= card.getAttribute('data-product-title') || undefined;
          item.image ??= card.getAttribute('data-product-image') || undefined;
          item.handle ??= card.getAttribute('data-product-handle') || undefined;
          item.url ??= card.getAttribute('data-product-url') || undefined;
          if (!item.title) {
            const titleEl = card.querySelector('.product-card__title, .card__heading');
            const text = titleEl && titleEl.textContent && titleEl.textContent.trim();
            if (text) item.title = text;
          }
          if (!item.image) {
            const img = card.querySelector('img.product-card__image--primary, .product-card__media img, img');
            const src = img && (img.currentSrc || img.getAttribute('src'));
            if (src) item.image = src;
          }
          if (!item.url) {
            const link = card.querySelector('a.product-card-link, a.product-card__image-link, a[href*="/products/"]');
            const href = link && link.getAttribute('href');
            if (href) item.url = href;
          }
          if (!item.handle && item.url) {
            const match = String(item.url).match(/\/products\/([^/?#]+)/);
            if (match) {
              try {
                item.handle = decodeURIComponent(match[1]);
              } catch (_) {
                item.handle = match[1];
              }
            }
          }
        }
      }
      return item;
    }

    _render() {
      const productId = this.getAttribute('data-product-id');
      if (!productId) return;
      const variantId = this.getAttribute('data-variant-id') || undefined;
      const filled = variantId
        ? store.has(productId, variantId) || store.hasProduct(productId)
        : store.hasProduct(productId);
      this.dataset.state = filled ? 'filled' : 'empty';
      this.classList.toggle('fab-wishlist-btn--filled', filled);
      this.classList.remove('fab-wishlist-btn--half');
      const label = filled
        ? t('wishlist.remove', 'Remove from wishlist')
        : t('wishlist.add', 'Add to wishlist');
      this.setAttribute('aria-label', label);
      this.setAttribute('aria-pressed', filled ? 'true' : 'false');
      this.title = label;
    }
  }

  // ---------------- <wishlist-count> ----------------

  class WishlistCount extends HTMLElement {
    constructor() { super(); this._unsubscribe = null; this._render = this._render.bind(this); }
    connectedCallback() {
      if (!this._built) { this.classList.add('fab-wishlist-count'); this.setAttribute('aria-hidden', 'true'); this._built = true; }
      this._unsubscribe = store.subscribe(this._render);
    }
    disconnectedCallback() { this._unsubscribe?.(); }
    _render(state) {
      const n = state.items.length;
      this.textContent = n > 0 ? String(n) : '';
      this.dataset.empty = n === 0 ? 'true' : 'false';
    }
  }

  // ---------------- <wishlist-page> ----------------

  class WishlistPage extends HTMLElement {
    constructor() { super(); this._unsubscribe = null; this._render = this._render.bind(this); }

    connectedCallback() {
      this._unsubscribe = store.subscribe(this._render);
      const hash = window.location.hash;
      if (hash.startsWith('#shared=')) {
        this._renderShared(hash.slice(8).split(',').filter(Boolean));
        return;
      }
      this._refreshFromShopify();
    }

    disconnectedCallback() { this._unsubscribe?.(); }

    async _refreshFromShopify() {
      const items = store.getItems();
      if (!items.length) return;
      const country = (window.Shopify?.country || 'GB').toUpperCase();
      const fresh = await fetchProductsFromStorefront(items, country);
      if (!fresh || !fresh.size) return;
      let updates = 0;
      fresh.forEach((meta, productId) => { store.updateMeta(productId, meta); updates++; });
      if (updates) store.persistAndBroadcast();
    }

    _render() {
      const items = store.getItems();
      const isSignedIn = !!(window.FabCustomerSession && window.FabCustomerSession.customerId);
      const loginUrl = loginUrlWithReturn();
      const hasItems = items.length > 0;

      // ---- Empty state ----
      if (!hasItems) {
        let emptyBanner = '';
        if (!isSignedIn) {
          emptyBanner = `
            <div class="fab-wishlist-page__signin-banner">
              <div class="fab-wishlist-page__signin-banner-content">
                <strong>${escapeText(t('wishlist.banner_empty_title', 'Already have a Fab account?'))}</strong>
                <span>${escapeText(t('wishlist.banner_empty_text', 'Sign in to find your saved wishlist from another device.'))}</span>
              </div>
              <div class="fab-wishlist-page__signin-banner-actions">
                <a href="${escapeAttr(loginUrl)}" class="fab-wishlist-page__signin-banner-btn">${escapeText(t('wishlist.signin', 'Sign in'))}</a>
              </div>
            </div>
          `;
        }
        this.innerHTML = `
          <div class="fab-wishlist-page__empty">
            ${emptyBanner}
            <div class="fab-wishlist-page__empty-inner">
              <h2 class="fab-wishlist-page__empty-title">${escapeText(t('wishlist.empty_title', 'Your wishlist is empty'))}</h2>
              <p class="fab-wishlist-page__empty-text">${escapeText(t('wishlist.empty_text', 'Save your favourite prints by tapping the heart icon on any product.'))}</p>
              <a href="${escapeAttr(routes().bestsellers || path('/collections/fab-favourites'))}" class="button">${escapeText(t('wishlist.empty_cta', 'Shop bestsellers'))}</a>
            </div>
          </div>
        `;
        return;
      }

      // ---- Product cards ----
      const cards = items.slice().reverse().map((it, idx) => {
        const meta = store.getMeta(it.productId) || {};
        const url = productUrl(meta);
        const title = meta.title || t('wishlist.loading', 'Loading\u2026');
        const image = meta.image || '';
        const altText = meta.imageAlt || title;
        const img195 = image ? this._resizedImage(image, 195) : '';
        const img300 = image ? this._resizedImage(image, 300) : '';
        const img450 = image ? this._resizedImage(image, 450) : '';
        const img600 = image ? this._resizedImage(image, 600) : '';
        const price = meta.price != null ? formatPrice(meta.price, meta.currency) : '';
        const priceCompare = meta.priceCompare != null && meta.priceCompare > meta.price ? formatPrice(meta.priceCompare, meta.currency) : '';
        const loading = idx < 4 ? 'eager' : 'lazy';
        const fetchPriority = idx < 4 ? 'high' : 'auto';

        return `
          <div class="grid__item">
            <div class="card-wrapper product-card-wrapper">
              <div class="product-card">
                <div class="product-card__media">
                  <button type="button" class="fab-wishlist-card__remove" data-product-id="${it.productId}" ${it.variantId ? `data-variant-id="${it.variantId}"` : ''} aria-label="${escapeAttr(t('wishlist.remove', 'Remove from wishlist'))}" title="${escapeAttr(t('wishlist.remove', 'Remove from wishlist'))}">
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>
                  </button>
                  <a href="${escapeAttr(url)}" class="product-card__image-link product-card-link">
                    <div class="aspect-ratio-box relative overflow-hidden" style="aspect-ratio: 225 / 292.5;">
                      ${image ? `
                        <img src="${escapeAttr(img300)}" srcset="${escapeAttr(img195)} 195w, ${escapeAttr(img300)} 300w, ${escapeAttr(img450)} 450w, ${escapeAttr(img600)} 600w" sizes="(max-width: 480px) 195px, (max-width: 768px) 300px, 300px" alt="${escapeAttr(altText)}" width="300" height="390" class="fab-wishlist-card__image absolute inset-0 w-full h-full object-cover" loading="${loading}" fetchpriority="${fetchPriority}" decoding="async">
                      ` : ''}
                    </div>
                  </a>
                </div>
                <div class="product-card__content">
                  <h3 class="product-card__title"><a href="${escapeAttr(url)}" class="product-card-link">${escapeText(title)}</a></h3>
                  <div class="product-card__price">
                    ${priceCompare
                      ? `<span class="product-card__price--sale">${price}</span> <s class="product-card__price--regular">${priceCompare}</s>`
                      : `<span class="product-card__price--regular">${price}</span>`}
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
      }).join('');

      // ---- Banner ----
      let signinBanner = '';
      if (!isSignedIn) {
        // Guest with items: Register + sign-in link + share
        signinBanner = `
          <div class="fab-wishlist-page__signin-banner">
            <div class="fab-wishlist-page__signin-banner-content">
              <strong>${escapeText(t('wishlist.banner_guest_title', 'Don\u2019t lose your wishlist'))}</strong>
              <span>${escapeText(t('wishlist.banner_guest_text', 'Create a free account so you can access your wishlist from any device.'))}</span>
            </div>
            <div class="fab-wishlist-page__signin-banner-actions">
              <a href="${escapeAttr(loginUrl)}" class="fab-wishlist-page__signin-banner-btn" data-track-label="register">${escapeText(t('wishlist.register', 'Register'))}</a>
              <button type="button" class="fab-wishlist-page__signin-banner-btn fab-wishlist-page__signin-banner-btn--secondary" data-track-label="share" onclick="FabWishlist._shareWishlist()">${escapeText(t('wishlist.share', 'Share wishlist'))}</button>
              <a href="${escapeAttr(loginUrl)}" class="fab-wishlist-page__signin-text-link" data-track-label="signin">${escapeText(t('wishlist.signin_link', 'Have a Fab account? Sign in here'))}</a>
            </div>
          </div>
        `;
      } else {
        // Signed-in: saved confirmation + share
        signinBanner = `
          <div class="fab-wishlist-page__signin-banner fab-wishlist-page__signin-banner--saved">
            <div class="fab-wishlist-page__signin-banner-content">
              <strong>${escapeText(t('wishlist.banner_saved_title', 'Your wishlist is saved'))}</strong>
              <span>${escapeText(t('wishlist.banner_saved_text', 'Access it from any device by signing in, or share it with friends and family.'))}</span>
            </div>
            <div class="fab-wishlist-page__signin-banner-actions">
              <button type="button" class="fab-wishlist-page__signin-banner-btn" onclick="FabWishlist._shareWishlist()">${escapeText(t('wishlist.share', 'Share wishlist'))}</button>
            </div>
          </div>
        `;
      }

      // ---- Assemble ----
      this.innerHTML = `
        <div class="product-grid-container">
          ${signinBanner}
          <div class="collection__grid">${cards}</div>
        </div>
      `;

      // ---- Wire up remove buttons ----
      this.querySelectorAll('.fab-wishlist-card__remove').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const pid = btn.getAttribute('data-product-id');
          const removedItems = store.getItems().filter((it) => String(it.productId) === String(pid));
          const meta = store.getMeta(pid) || {};
          removedItems.forEach((it) => store.remove(it.productId, it.variantId));
          showToast(t('wishlist.removed', 'Removed from wishlist'), () => { removedItems.forEach((it) => { store.add({ ...it, ...meta }); }); });
        });
      });

      // ---- Track banner impression ----
      if (!isSignedIn && hasItems) {
        try {
          if (window.__fabTrackingHelpers && window.__fabTrackingHelpers.capture) {
            window.__fabTrackingHelpers.capture('wishlist_signup_banner_shown', {
              wishlist_count: items.length,
              banner_type: 'guest_with_items'
            });
          }
        } catch (_) {}

        this.querySelectorAll('.fab-wishlist-page__signin-banner-btn, .fab-wishlist-page__signin-text-link').forEach(function (link) {
          link.addEventListener('click', function () {
            try {
              if (window.__fabTrackingHelpers && window.__fabTrackingHelpers.capture) {
                window.__fabTrackingHelpers.capture('wishlist_signup_banner_clicked', {
                  wishlist_count: items.length,
                  // Locale-stable so the dimension doesn't fragment per market.
                  click_target: link.getAttribute('data-track-label') || link.textContent.trim()
                });
              }
            } catch (_) {}
          });
        });
      }
    }



    async _renderShared(productIds) {
      if (!productIds.length) return;
      this.innerHTML =
        '<div class="fab-wishlist-page__empty"><p>' +
        escapeText(t('wishlist.shared_loading', 'Loading shared wishlist\u2026')) +
        '</p></div>';

      const country = (window.Shopify?.country || 'GB').toUpperCase();
      const items = productIds.map((id) => ({ productId: id }));
      const fresh = await fetchProductsFromStorefront(items, country);

      if (!fresh || !fresh.size) {
        this.innerHTML =
          '<div class="fab-wishlist-page__empty"><p>' +
          escapeText(t('wishlist.shared_error', 'Couldn\u2019t load this shared wishlist.')) +
          '</p></div>';
        return;
      }
      

      // Shared cards include a wishlist heart so visitors can save items
      const cards = productIds.map((pid, idx) => {
        const meta = fresh.get(pid);
        if (!meta) return '';
        const url = productUrl(meta);
        const image = meta.image || '';
        const img195 = image ? this._resizedImage(image, 195) : '';
        const img300 = image ? this._resizedImage(image, 300) : '';
        const img450 = image ? this._resizedImage(image, 450) : '';
        const img600 = image ? this._resizedImage(image, 600) : '';
        const price = meta.price != null ? formatPrice(meta.price, meta.currency) : '';
        const priceCompare = meta.priceCompare != null && meta.priceCompare > meta.price ? formatPrice(meta.priceCompare, meta.currency) : '';

        // Wishlist heart button — rendered as raw HTML, the custom element
        // self-initialises via connectedCallback when inserted into the DOM.
        const heartBtn = `<wishlist-button
          class="fab-wishlist-btn"
          data-product-id="${escapeAttr(pid)}"
          data-product-title="${escapeAttr(meta.title)}"
          data-product-handle="${escapeAttr(meta.handle || '')}"
          data-product-image="${escapeAttr(meta.image || '')}"
          data-product-url="${escapeAttr(url)}"
          data-product-price="${meta.price != null ? meta.price : ''}"
          data-product-price-compare="${meta.priceCompare != null ? meta.priceCompare : ''}"
        ></wishlist-button>`;

        return `
          <div class="grid__item">
            <div class="card-wrapper product-card-wrapper">
              <div class="product-card">
                <div class="product-card__media">
                  ${heartBtn}
                  <a href="${escapeAttr(url)}" class="product-card__image-link product-card-link">
                    <div class="aspect-ratio-box relative overflow-hidden" style="aspect-ratio: 225 / 292.5;">
                      ${image ? `
                        <img src="${escapeAttr(img300)}" srcset="${escapeAttr(img195)} 195w, ${escapeAttr(img300)} 300w, ${escapeAttr(img450)} 450w, ${escapeAttr(img600)} 600w" sizes="(max-width: 480px) 195px, (max-width: 768px) 300px, 300px" alt="${escapeAttr(meta.imageAlt || meta.title)}" width="300" height="390" class="fab-wishlist-card__image absolute inset-0 w-full h-full object-cover" loading="${idx < 4 ? 'eager' : 'lazy'}" fetchpriority="${idx < 4 ? 'high' : 'auto'}" decoding="async">
                      ` : ''}
                    </div>
                  </a>
                </div>
                <div class="product-card__content">
                  <h3 class="product-card__title"><a href="${escapeAttr(url)}" class="product-card-link">${escapeText(meta.title)}</a></h3>
                  <div class="product-card__price">
                    ${priceCompare
                      ? `<span class="product-card__price--sale">${price}</span> <s class="product-card__price--regular">${priceCompare}</s>`
                      : `<span class="product-card__price--regular">${price}</span>`}
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
      }).filter(Boolean).join('');

      this.innerHTML = `
        <div class="product-grid-container">
          <div class="collection__grid">${cards}</div>
        </div>
      `;
    }

    _resizedImage(src, width, quality) {
      if (!src) return '';
      try {
        const u = new URL(src.startsWith('//') ? `https:${src}` : src, window.location.origin);
        u.searchParams.delete('width');
        u.searchParams.delete('quality');
        u.searchParams.set('width', String(width));
        if (quality != null) u.searchParams.set('quality', String(quality));
        return u.toString();
      } catch (_) { return src; }
    }
  }

  // ---------------- share wishlist ----------------

  function shareWishlist() {
    const items = store.getItems();
    if (!items.length) return;
    const ids = items.map((it) => String(it.productId)).join(',');
    const sharedPath = routes().sharedWishlist || path('/pages/shared-wishlist');
    const shareUrl = window.location.origin + sharedPath + '#shared=' + ids;

    // Mobile: use Web Share API for native share sheet
    // Desktop: always clipboard copy (more reliable, no awkward share dialog)
    if (isMobile() && navigator.share) {
      navigator.share({
        title: t('wishlist.share_title', 'My Fab Art Wishlist'),
        text: t('wishlist.share_text', 'Check out my wishlist on Fab Art'),
        url: shareUrl,
      }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(shareUrl).then(() => {
        // Update the button text instead of showing a toast
        var btn = document.querySelector('.fab-wishlist-page__share-btn') ||
                  document.querySelector('[onclick*="_shareWishlist"]');
        if (btn) {
          var original = btn.textContent;
          btn.textContent = t('wishlist.share_copied', 'Wishlist link copied');
          btn.disabled = true;
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 3000);
        }
      }).catch(() => {
        showToast(t('wishlist.share_error', 'Couldn\u2019t copy link'));
      });
    }
  }

  // ---------------- helpers ----------------

  function formatPrice(cents, currency) {
    if (typeof cents !== 'number') return '';
    const code = currency || window.Shopify?.currency?.active || 'GBP';
    try {
      return new Intl.NumberFormat(navigator.language || 'en-GB', {
        style: 'currency', currency: code, currencyDisplay: 'narrowSymbol',
      }).format(cents / 100);
    } catch (_) { return `${code} ${(cents / 100).toFixed(2)}`; }
  }

  function escapeAttr(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
  function escapeText(s) { return escapeAttr(s); }

  // ---------------- bootstrap ----------------

  /** Kill mobile "shimmer"/flicker from component-card layering (contain/paint + opacity transitions on .product-card__image--primary). */
  function injectFabWishlistImageStyles() {
    if (typeof document === 'undefined') return;
    if (document.getElementById('fab-wishlist-card-image-styles')) return;
    const el = document.createElement('style');
    el.id = 'fab-wishlist-card-image-styles';
    el.textContent =
      '.fab-wishlist-page wishlist-page .fab-wishlist-card__image{' +
      'opacity:1!important;transition:none!important;animation:none!important;will-change:auto!important;' +
      '}' +
      '.fab-wishlist-page wishlist-page .card-wrapper{' +
      'contain:layout style!important;will-change:auto!important;backface-visibility:visible!important;transform:none!important;' +
      '}' +
      '.fab-wishlist-page wishlist-page .aspect-ratio-box{background-color:transparent;background-image:none}';
    document.head.appendChild(el);
  }

  function defineCustomElements() {
    if (!customElements.get('wishlist-button')) customElements.define('wishlist-button', WishlistButton);
    if (!customElements.get('wishlist-count')) customElements.define('wishlist-count', WishlistCount);
    if (!customElements.get('wishlist-page')) customElements.define('wishlist-page', WishlistPage);
  }

  function init() {
    injectFabWishlistImageStyles();
    defineCustomElements();
    migrate();

    if (window.FabCustomerSession && window.FabCustomerSession.customerId) {
      store.signIn(window.FabCustomerSession);
    }
  }

  // ---------------- expose & start ----------------

  window.FabWishlist = {
    store,
    showToast,
    signIn: store.signIn,
    signOut: store.signOut,
    _shareWishlist: shareWishlist,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

})();
